<template>
  <div class="space-y-0.5">
    <div
      v-for="dept in treeData"
      :key="dept.id"
      class="tree-item rounded-lg cursor-pointer"
      :class="{ 'bg-primary-50': selectedDeptId === dept.id }"
    >
      <div class="flex items-center gap-2 px-2 py-1.5" @click="handleSelect(dept)">
        <!-- 展开/收起箭头 -->
        <svg
          v-if="dept.children?.length"
          class="w-4 h-4 text-slate-400 transition-transform flex-shrink-0"
          :class="expandedIds[dept.id] ? 'rotate-0' : '-rotate-90'"
          @click.stop="handleToggle(dept)"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
        <span v-else class="w-4 h-4 flex-shrink-0"></span>
        <!-- 部门图标 -->
        <svg class="w-4 h-4 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 00-2 0v1H8a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2h-1V9z" clip-rule="evenodd"/>
        </svg>
        <span class="text-sm text-slate-700 truncate">{{ dept.name }}</span>
      </div>
      <!-- 递归渲染子部�?-->
      <div
        v-if="dept.children?.length && expandedIds[dept.id]"
        class="ml-4 border-l border-slate-200 pl-2"
      >
        <DeptTree
          :tree-data="dept.children"
          :selected-dept-id="selectedDeptId"
          :expanded-ids="expandedIds"
          @select="onSelect"
          @toggle="emit('toggle', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  treeData: { type: Array, default: () => [] },
  selectedDeptId: { type: [Number, String], default: null },
  expandedIds: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['select', 'toggle'])

const handleSelect = (dept) => {
  emit('select', dept)
}

const handleToggle = (dept) => {
  if (dept.children?.length) {
    emit('toggle', dept.id)
  }
}

const onSelect = (dept) => {
  emit('select', dept)
}
</script>



